module.exports = __webpack_public_path__ + "media/images/icon__locked-143bd67f5ae7f934f95ca3264132cf72.png";